(function () {
	function swiperInit() {
		if (typeof Swiper === 'undefined') return false;

		document
			.querySelectorAll(
				'.js-media-list.swiper-initialized, .js-media-sublist.swiper-initialized, .js-popup-slider.swiper-initialized'
			)
			.forEach(function (el) {
				if (el.swiper) el.swiper.destroy(true, true);
			});

		subSliderInit(true, 16);
		sliderInit(true);
		popupSliderInit(true);
		return true;
	}

	function waitForSwiper(attempt) {
		if (swiperInit()) return;
		if (attempt > 100) return;
		setTimeout(function () {
			waitForSwiper(attempt + 1);
		}, 50);
	}

	document.addEventListener('shopify:section:load', function () {
		waitForSwiper(0);
	});

	if (document.readyState === 'loading') {
		document.addEventListener('DOMContentLoaded', function () {
			waitForSwiper(0);
		});
	} else {
		waitForSwiper(0);
	}
})();
